/**
 * Typed access to Vite env variables. Throws early on missing required keys
 * so we never silently 401 against Supabase in production.
 */

function required(name: string, value: string | undefined): string {
  if (!value) throw new Error(`Missing required env var: ${name}`);
  return value;
}

export const env = {
  supabase: {
    url: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
    anonKey: required('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY),
  },
  stripe: {
    publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '',
  },
  app: {
    name: 'CodeClasse',
    url: import.meta.env.VITE_APP_URL ?? 'http://localhost:5174',
    isProd: import.meta.env.PROD,
  },
} as const;
